import {enableProdMode} from "@angular/core";
import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";

import {AppModule} from "./app/app.module";
import {environment} from "./environments/environment";
import {FelloEnv} from "fello-model";
import * as Sentry from "@sentry/angular-ivy";
import {SentryUtils} from "fello-common";
import versionInfo from "../version.json";

// Errors thrown by third party scripts we embed. They are unactionable for us and drown out our own.
const SENTRY_DENY_URLS = [
  /static\.hotjar\.com/i,
  /js\.hs-scripts\.com/i,
  /js\.hs-analytics\.net/i,
  /js\.hsforms\.net/i,
  /cdn\.mxpnl\.com/i,
  /maps\.googleapis\.com/i,
  /js\.chargebee\.com/i,
  /googletagmanager\.com/i,
  /^chrome-extension:\/\//i,
  /^moz-extension:\/\//i,
  /^safari-(web-)?extension:\/\//i
];

const SENTRY_IGNORE_ERRORS = [
  // Cross-origin script errors, opaque by design.
  "Script error.",
  // Benign layout churn, reported by Chrome only.
  "ResizeObserver loop limit exceeded",
  "ResizeObserver loop completed with undelivered notifications",
  // Navigating away mid-request on a public funnel is normal, not a fault.
  "AbortError: The operation was aborted",
  "Non-Error promise rejection captured"
];

if (environment.sentryDsn) {
  Sentry.init({
    dsn: environment.sentryDsn,
    // The Angular flavour of this integration instruments the router itself; it still needs
    // SENTRY_PROVIDERS to supply TraceService.
    integrations: [Sentry.browserTracingIntegration()],
    // Distributed tracing stays off until turboengine allows the sentry-trace and baggage headers.
    // An empty list keeps them out of the CORS preflight, which would otherwise start failing for
    // every cross-origin API call.
    tracePropagationTargets: [],
    environment: environment.env,
    release: `consumer-${environment.env}@${versionInfo.version}`,
    beforeSend: SentryUtils.beforeSend,
    denyUrls: SENTRY_DENY_URLS,
    ignoreErrors: SENTRY_IGNORE_ERRORS,
    tracesSampleRate: environment.sentryTracesSampleRate
  });
}

if (environment.production && environment.env === FelloEnv.PROD) {
  enableProdMode();
}

function bootstrap() {
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch(err => console.error(err));
}

if (document.readyState === "complete") {
  bootstrap();
} else {
  document.addEventListener("DOMContentLoaded", bootstrap);
}
